import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";

import AppLayout from "./components/AppLayout";
import ProtectedRoute from "./components/ProtectedRoute";

import Welcome from "./pages/Welcome";
import Auth from "./pages/Auth";
import Home from "./pages/Home";
import CalendarPage from "./pages/CalendarPage";
import ExperienceDetail from "./pages/ExperienceDetail";
import Booking from "./pages/Booking";
import Payment from "./pages/Payment";
import Confirmation from "./pages/Confirmation";
import Trips from "./pages/Trips";
import Profile from "./pages/Profile";
import Notifications from "./pages/Notifications";
import Legal from "./pages/Legal";
import SitemapPage from "./pages/Sitemap";

import "./App.css";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/auth" element={<Auth />} />

            {/* Public — legal & sitemap */}
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/sitemap" element={<SitemapPage />} />

            {/* App routes with bottom + top navigation */}
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/home" element={<Home />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/trips" element={<Trips />} />
              <Route path="/profile" element={<Profile />} />
            </Route>

            {/* App routes without navigation (focused flows) */}
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout withNav={false} />
                </ProtectedRoute>
              }
            >
              <Route path="/experiences/:id" element={<ExperienceDetail />} />
              <Route path="/book/:id" element={<Booking />} />
              <Route path="/payment/:bookingId" element={<Payment />} />
              <Route path="/confirmation/:bookingId" element={<Confirmation />} />
              <Route path="/profile/notifications" element={<Notifications />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
